import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Clock, ArrowDownLeft, ArrowUpRight, ShieldAlert, Ban } from "lucide-react";
import { DashLayout } from "@/components/DashLayout";
import { PayoutTable } from "@/components/Tables";
import { api, inr } from "@/lib/api";
import { ADMIN_NAV } from "@/pages/navs";

const Stat = ({ icon: I, label, value, tone, testid }) => (
  <div className="rise rounded-xl border border-slate-200 bg-white p-5" data-testid={testid}>
    <div className="flex items-center justify-between text-sm font-medium text-slate-500">{label}<I className={`h-4 w-4 ${tone}`} /></div>
    <div className="mt-3 font-display text-2xl font-bold text-[#0A1F44]">{value}</div>
  </div>
);

export default function AdminOverview() {
  const [s, setS] = useState(null);
  const [pending, setPending] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data));
    api.get("/admin/payouts", { params: { status: "pending" } }).then((r) => setPending(r.data.slice(0, 6)));
  }, []);

  return (
    <DashLayout nav={ADMIN_NAV} title="Admin Overview" subtitle="YesPayBizz control center">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Stat testid="stat-users" icon={Users} label="Total merchants" value={s?.count ?? "-"} tone="text-blue-600" />
        <Stat testid="stat-blocked" icon={Ban} label="Blocked merchants" value={s?.blocked ?? "-"} tone="text-rose-500" />
        <Stat testid="stat-pending" icon={Clock} label="Pending payouts" value={s ? `${s.pending_payouts} · ${inr(s.pending_amount)}` : "-"} tone="text-amber-500" />
        <Stat testid="stat-collection" icon={ArrowDownLeft} label="Total collection balance" value={inr(s?.collection)} tone="text-emerald-600" />
        <Stat testid="stat-payout" icon={ArrowUpRight} label="Total payout balance" value={inr(s?.payout)} tone="text-blue-600" />
        <Stat testid="stat-chargeback" icon={ShieldAlert} label="Total chargeback balance" value={inr(s?.chargeback)} tone="text-amber-500" />
      </div>
      <div>
        <div className="mb-3 flex items-center justify-between">
          <h2 className="font-display text-lg font-semibold text-[#0A1F44]">Pending payout requests</h2>
          <Link to="/admin/payouts" className="text-sm font-semibold text-[#2563EB]" data-testid="view-all-payouts">Manage</Link>
        </div>
        <PayoutTable rows={pending} showUser />
      </div>
    </DashLayout>
  );
}
